import { z } from 'zod';
import { apiGet, apiPost } from '../client';
import { MerchantCheckoutSchema } from '../schemas';

const ListResponse = z.object({ data: z.array(MerchantCheckoutSchema) });
const ReviewResponse = z.object({ data: MerchantCheckoutSchema });
const Decision = z.object({ approvedAmountCents: z.number().int().positive().nullable() }).strict();

export function listMerchantCheckouts() {
  return apiGet('/v1/business/payment-checkouts', ListResponse);
}

export async function reviewRefund(checkoutId: string, decision: z.infer<typeof Decision>, key: string) {
  const response = await apiPost(`/v1/business/payment-checkouts/${encodeURIComponent(checkoutId)}/refund-review`,
    ReviewResponse, Decision.parse(decision), key);
  return response.data;
}
